/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

export type ShippingStatus = (typeof ShippingStatus)[keyof typeof ShippingStatus];

export const ShippingStatus = {
	PENDING: 'PENDING',
	PREPARING: 'PREPARING',
	SHIPPED: 'SHIPPED',
	IN_TRANSIT: 'IN_TRANSIT',
	DELIVERED: 'DELIVERED',
	RETURNED: 'RETURNED'
} as const;
